export default {"src":"/_next/static/media/volkskrant.eb21ebd7.svg","height":21,"width":160,"blurWidth":0,"blurHeight":0};